import styled from "styled-components";

import { Layout } from "antd";

import { colors, fonts } from "@app/theme.ts";

export const StyledLayout = styled(Layout)`
  height: 100vh;
  overflow: hidden;
`;

export const StyledLayoutSider = styled(Layout.Sider)`
  height: 100vh;

  &.ant-layout-sider {
    background: ${colors.navy};
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }

  .ant-layout-sider-trigger {
    background: ${colors["navy-2"]};
  }
`;

export const StyledBrand = styled.a`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  padding: 1.5rem 1.5rem 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: none;
`;

export const StyledBrandName = styled.span`
  color: ${colors.white};
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

export const StyledBrandTag = styled.span`
  color: ${colors.pink};
  font-family: ${fonts.hand};
  font-size: 1.5rem;
  font-weight: 700;
`;

export const StyledContent = styled(Layout.Content)`
  height: 100%;
  overflow: auto;
  padding: 2rem 2.5rem;

  @media (max-width: 768px) {
    padding: 1.25rem 1rem;
  }
`;

export const StyledContentInner = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;
